
import React from 'react';

interface ResponseTimeIndicatorProps {
  text: string;
}

const ResponseTimeIndicator: React.FC<ResponseTimeIndicatorProps> = ({ text }) => {
  return (
    <div className="mt-6 text-xs text-gray-400 flex items-center justify-center">
      <svg 
        viewBox="0 0 24 24" 
        className="w-4 h-4 mr-1 text-purple-400"
        fill="none" 
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
      <span>{text}</span>
    </div>
  );
};

export default ResponseTimeIndicator;
